import {
    Grid,
    GridProps,
} from '@chakra-ui/react';
import { CulinaryStudioArticlePortionModel } from 'entities';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { CulinaryStudioArticlePageMainPortionCard } from './CulinaryStudioArticlePageMainPortionCard';

export type CulinaryStudioArticlePageMainPortionPickerProps = {
    culinaryStudioArticlePortions: CulinaryStudioArticlePortionModel[]
} & GridProps & React.RefAttributes<HTMLDivElement>;

export const CulinaryStudioArticlePageMainPortionPicker
: React.FC<CulinaryStudioArticlePageMainPortionPickerProps> = ({
    culinaryStudioArticlePortions,
    ...restProps
}) => (
    <Grid gap="2rem" {...restProps}>
        <Grid
            gap="2rem"
            width="100%"
        >
            {
                culinaryStudioArticlePortions?.map(({
                    value,
                    meassure,
                    description,
                    weight,
                    price,
                    currency,
                }) => (
                    <CulinaryStudioArticlePageMainPortionCard
                        width="100%"
                        value={value}
                        measure={meassure.toLocaleUpperCase()}
                        description={description}
                        weight={weight}
                        price={price}
                        currency={currency?.abbreviation}
                        isActive={false}
                    />
                ))
            }
        </Grid>

    </Grid>
);
